import 'css-chunksrc/client/scenes/inviteMembers/messageInput/styles.scss';export default {
  "messageInput": "_messageInput_h22j0_1"
};